
<section class="Wallet-secrion">
    <div class="container">
        <div class="row">
            <div class="col-md-12 wallet-div">
                <div class="wallet-heading">
                    <h1>
                        <div class="icon">
                            <i class='bx bx-wallet-alt'></i>
                        </div> Wallet
                    </h1>
                </div>
                <div class="balance-list">
                    <div class="tpls-cash-and-coins">
                        <div class="title">
                            <h4>Total Cash</h4>
                            <h6>{{totalAvailableCash}}</h6>
                        </div>
                    
                    </div>
                   
                </div>
                <div class="col-md-12 redemption">
                    <button class="redeem" (click)="transferAmountToBank(this.userId)">
                        Transfer Amount to Bank <i class='bx bx-up-arrow-alt'></i>
                    </button>
                    <!-- <button class="ml-3 redeem" (click)="kyclink(this.userId)" style="background: #000!important; color: #fff!important;">
                        Update KYC <i class='bx bx-up-arrow-alt' style="background: #d4ee26 !important; color: #000!important;"></i>
                    </button>
                    
                    <div class="kyc-alert">
                        <h4>KYC Incomplete</h4>
                        <p>To transfer money to your bank, you must first update your KYC.</p>
                    </div> -->
                </div>
                <div class=" col-md-12 transation-history">
                    <div class="table-div w-100">
                        <p-table #dt [value]="walletlist" [paginator]="true" [rows]="10" [lazy]="true" appendTo="body"
                            [autoLayout]="true" (onLazyLoad)="loadWalletHistory($event)" [totalRecords]="totalRecords"
                            [loading]="loading" [rowsPerPageOptions]="paginationOption">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="display: table-cell!important;" pSortableColumn="id"
                                        class="transactionId">Transaction ID</th>
                                    <th style="display: table-cell!important;" pSortableColumn="description"
                                        class="transactiodescription">Description</th>
                                    <th style="display: table-cell!important;" pSortableColumn="created_at"
                                        class="date">Date</th>
                                        <th style="display: table-cell!important;" pSortableColumn="email"
                                        class="amount-div">TDS</th>

                                    <th style="display: table-cell!important;" pSortableColumn="email"
                                        class="amount-div"> Total Amount</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-wallet>
                                <tr class="p-selectable-row">
                                    <td class="transactionId">
                                        {{wallet.id}}
                                    </td>
                                    <td class="transactiodescription">
                                        {{wallet.description}}
                                    </td>
                                    <td class="date">
                                        {{wallet.created_at | date: 'dd MMM, yyyy'}}
                                    </td>
                                   
                                    <td *ngIf="wallet.cash!=0">
                                        ₹ 100
                                        <!-- <div class="debit" *ngIf="wallet.action=='ADD'">
                                            <i class='bx bx-plus'></i> {{wallet.cash}} {{wallet.wallettype | lowercase}}<span></span>
                                        </div>
                                        <div class="credits" *ngIf="wallet.action=='SUBTRACT'">
                                            <i class='bx bx-minus'></i> {{wallet.cash}} {{wallet.wallettype | lowercase}} <span></span>
                                        </div> -->
                                    </td>
                                    <td *ngIf="wallet.action=='ADD'" class="amount-div">
                                        <i class='bx bx-plus'></i> {{wallet.amount}} {{wallet.wallettype | lowercase }}
                                    </td>
                                    <td *ngIf="wallet.action=='SUBTRACT'" class="amount-div">
                                        <i class='bx bx-minus'></i> {{wallet.amount}} {{wallet.wallettype | lowercase }}
                                    </td>
                                    <!-- <td *ngIf="wallet.coins!=0">                                    
                                    <div class="debit" *ngIf="wallet.action=='ADD'">
                                        <i class='bx bx-plus'></i> {{wallet.coins}} {{wallet.wallettype | lowercase }}<span></span>
                                    </div>
                                    <div class="credits" *ngIf="wallet.action=='SUBTRACT'">
                                        <i class='bx bx-minus'></i> {{wallet.coins}} {{wallet.wallettype | lowercase}} <span></span>
                                    </div>
                                    
                                </td>-->
                              
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<p-dialog class="add-amont-popup" [(visible)]="addCashmodal" [modal]="true" [style]="{width: '500px'}" header="Add Cash"
    [breakpoints]="{'960px': '60vw', '640px': '100vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false"
    (onHide)="cashclose()">

    <form [formGroup]="addCashForm" *ngIf="this.addCashForm">
        <div class="p-fluid p-formgrid p-grid">
            <div class="wallet-icons">
                <div class="icon"><i class="bx bx-wallet-alt"></i></div>
                <h1>Enter Amount</h1>
            </div>
            <div class="p-field p-col-12">
                <!-- <label for="amount">Amount<span class="mandatory-fields">*</span></label> -->
                <input formControlName="amount" type="text" pInputText class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.amount.errors }" placeholder="₹ 0">
                <div *ngIf="submitted && f.amount.errors" class="invalid-feedback">
                    <div *ngIf="f.amount.errors.required">Amount is required</div>
                    <div *ngIf="!f.amount.errors.required && f.amount.errors">Only Numbers allowed</div>
                </div>
            </div>
            <div class="p-field p-col-12 msg-div">
                <p-messages severity="info">
                    <ng-template pTemplate>
                       <i class="pi pi-info-circle"></i>
                        <div class="ml-2">Please Note: For iPhone users - To make a payment using Gpay, select "Others" option in the UPI menu and manually enter your UPI ID.
                        </div>
                    </ng-template>
                </p-messages>
               
            </div>
        </div>
        <div class="col-md-12 text-center">

            <button type="button" (click)="onCashSubmit()" pButton label="Add To Wallet"
                class="p-button-primery save-btn p-mr-0" style="width: auto"></button>
        </div>
    </form>
</p-dialog>
<p-dialog [(visible)]="showThankyouModal" [modal]="true" [style]="{width: '500'}" header="Thank You"
    [breakpoints]="{'960px': '60vw', '640px': '100vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false"
    (onHide)="closeThankyou()">
    <div class="col-md-12">
        Amount added to Wallet Successfully.
    </div>
</p-dialog>

<p-dialog class="add-amont-popup" [(visible)]="addCoinmodal" [modal]="true" [style]="{width: '500px'}"
    header="Add Coins" [breakpoints]="{'960px': '60vw', '640px': '100vw'}" [baseZIndex]="10000" [draggable]="false"
    [resizable]="false" (onHide)="coinclose()">
    <!-- <form [formGroup]="addCoinForm" *ngIf="this.addCoinForm">
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12">
                <label for="amount">Amount<span class="mandatory-fields">*</span></label>
                <input formControlName="amount" type="text" pInputText class="form-control"
                    [ngClass]="{ 'is-invalid': coinsubmitted && f1.amount.errors }">
                <div *ngIf="coinsubmitted && f1.amount.errors" class="invalid-feedback">
                    <div *ngIf="f1.amount.errors.required">Amount is required</div>
                    <div *ngIf="!f1.amount.errors.required && f1.amount.errors">Only Numbers allowed</div>
                </div>
            </div>
            <div class="p-field p-col-12">Note: 1 Cash equal to 10 Coins</div>
        </div>
        <button type="button" (click)="onCoinSubmit()" pButton icon="pi pi-check" label="Checkout"
            class="p-button-success save-btn p-mr-0" style="width: auto"></button>
    </form> -->

    <form [formGroup]="addCoinForm" *ngIf="this.addCoinForm">
        <div class="p-fluid p-formgrid p-grid">
            <div class="wallet-icons">
                <div class="icon"><i class="bx bx-wallet-alt"></i></div>
                <h1>Enter Amount</h1>
            </div>
            <div class="p-field p-col-12 mb-0">
                <!-- <label for="amount">Amount<span class="mandatory-fields">*</span></label> -->
                <input formControlName="amount" type="text" pInputText class="form-control"
                    [ngClass]="{ 'is-invalid': coinsubmitted && f1.amount.errors }" placeholder="₹ 0">
                <div *ngIf="coinsubmitted && f1.amount.errors" class="invalid-feedback">
                    <div *ngIf="f1.amount.errors.required">Amount is required</div>
                    <div *ngIf="!f1.amount.errors.required && f1.amount.errors">Only Numbers allowed</div>
                </div>
            </div>
            <div class="p-field p-col-12  text-center" style="color:#000;">Note: 1 Cash equal to 10 Coins</div>
        </div>
        <div class="col-md-12 text-center">

            <button type="button" (click)="onCoinSubmit()" pButton label="Add To Wallet"
                class="p-button-primery save-btn p-mr-0" style="width: auto"></button>
        </div>
    </form>

</p-dialog>